import { render, staticRenderFns } from "./ModalLinkPeople.vue?vue&type=template&id=66c834e6&"
import script from "./ModalLinkPeople.vue?vue&type=script&lang=js&"
export * from "./ModalLinkPeople.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkPeople.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports